export const strings = {
  en: {
    beamAttribution: () => `Powered by Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  fr: {
    beamAttribution: () => `Optimisé par Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  de: {
    beamAttribution: () => `Unterstützt von Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  es: {
    beamAttribution: () => `Desarrollado por Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  it: {
    beamAttribution: () => `Offerto da Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  pl: {
    beamAttribution: () => `Wspierane przez Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
  ja: {
    beamAttribution: () => `Powered by Beam`,
    ctaTitle: () => `Choose Your Impact`,
    ctaMessage: ({ donationPercentage = "1%" } = {}) =>
      `Choose a nonprofit and ${donationPercentage} will be donated there for you,at no extra cost, with every order of your subscription.`,
  },
};
